export default class CompanyDBList {

	constructor (data) {
		this.data = data

		// Build id index
		this.index = {}
		for (let entry of this.data) {
			this.index[entry.id] = entry
		}

		// Build name index
		this.name_index = {}
		for (let entry of this.data) {
			this.name_index[entry.db_name] = entry
		}
	}

	static async fetch () {

		let data = await Anvil.REST.get('/c_order/company_db')

		return new CompanyDBList(data)
	}

	getById (id) {
		return this.index[id]
	}

	getByName (db_name) {
		return this.name_index[db_name]
	}
}
